module.exports = __webpack_public_path__ + "miscusi_logo-qZE.svg";